import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import styled, { css } from 'styled-components';
import { Typography as BaseTypography } from '@material-ui/core';
const Typography = styled(BaseTypography).withConfig({
  displayName: "FieldTypography__Typography",
  componentId: "l6tenl-0"
})(["&&{display:", ";}", ""], props => props['display-cs'], props => props['white-space'] ? css(["white-space:", ";"], props['white-space']) : '');
export const FieldTypography = (_ref) => {
  let {
    children,
    whiteSpace,
    display = 'inline'
  } = _ref,
      props = _objectWithoutProperties(_ref, ["children", "whiteSpace", "display"]);

  return /*#__PURE__*/React.createElement(Typography, _extends({
    component: "span",
    "display-cs": display,
    "white-space": whiteSpace
  }, props), children);
};